/* ============================================================
   TMS Custom – Total Mobile Store
   Section 1: Color-variant swatch on PDP
   Section 2: Client-side filter bar + bottom sheet (mobile)
   Section 3: Sort By
   ============================================================ */

/* ---------- SECTION 1 – Color Variant Picker (PDP) ---------- */
(function(){
  var defined=false;
  function initVariant(){
    if(defined)return;
    var sel=document.querySelector('variant-selects');
    if(!sel)return;
    defined=true;
    var radios=sel.querySelectorAll('input[type="radio"]');
    if(!radios.length)return;
    radios.forEach(function(r){
      r.addEventListener('change',function(){
        var lbl=r.closest('label')||r.parentElement;
        var wrap=lbl.closest('fieldset')||lbl.parentElement;
        wrap.querySelectorAll('label').forEach(function(l){l.classList.remove('is-selected')});
        if(lbl)lbl.classList.add('is-selected');
      });
    });
  }
  document.addEventListener('DOMContentLoaded',initVariant);
  if(document.readyState!=='loading')initVariant();
})();

/* ---------- SECTION 2 & 3 – Filter Bar + Sort + Client-Side Filtering ---------- */
(function(){
  /* ---- helpers ---- */
  function isMobile(){return window.innerWidth<=768}
  function capitalize(s){return s.charAt(0).toUpperCase()+s.slice(1)}

  /* ---- state ---- */
  var activeFilters={brand:[],color:[],storage:[],availability:[]};
  var priceRange={min:0,max:Infinity};
  var currentSort='best-selling';
  var productData=[];
  var originalOrder=[];

  /* ---- wait for DOM ---- */
  function init(){
    var path=window.location.pathname.replace(/\/+$/,'');
    var phonePages=['/collections/phones','/collections/iphones','/collections/samsung-galaxy'];
    if(phonePages.indexOf(path)===-1)return;

    var grid=document.querySelector('.product-grid__container');
    if(!grid){setTimeout(init,200);return}

    /* create the filter bar wrapper and insert before the grid */
    var wrap=document.createElement('div');
    wrap.className='tms-filter-bar-wrap';
    grid.parentNode.insertBefore(wrap,grid);

    loadProductData(function(){
      buildFilterBar();
      applyFilters();
    });
  }

  /* ---- load product data from Shopify JSON ---- */
  function loadProductData(cb){
    var path=window.location.pathname;
    var match=path.match(/\/collections\/([^\/\?#]+)/);
    if(!match){cb();return}
    var handle=match[1];
    fetch('/collections/'+handle+'/products.json?limit=250')
    .then(function(r){return r.json()})
    .then(function(d){
      var cards=document.querySelectorAll('.product-card');
      originalOrder=Array.from(cards).map(function(c){
        var m=c.id.match(/product-card-(\d+)/);
        return m?m[1]:'';
      });
      d.products.forEach(function(p){
        var colors=[];var storages=[];
        p.tags.forEach(function(t){
          if(t.indexOf('color-')===0)colors.push(t.replace('color-',''));
          if(t.indexOf('storage-')===0)storages.push(t.replace('storage-',''));
        });
        var prices=p.variants.map(function(v){return parseFloat(v.price)});
        var minPrice=Math.min.apply(null,prices);
        var maxPrice=Math.max.apply(null,prices);
        var hasAvailable=p.variants.some(function(v){return v.available});
        productData.push({
          id:String(p.id),
          title:p.title,
          vendor:p.vendor,
          colors:colors,
          storages:storages,
          minPrice:minPrice,
          maxPrice:maxPrice,
          available:hasAvailable,
          handle:p.handle
        });
      });
      var allMin=[];var allMax=[];
      productData.forEach(function(p){allMin.push(p.minPrice);allMax.push(p.maxPrice)});
      if(allMin.length){
        priceRange.globalMin=Math.min.apply(null,allMin);
        priceRange.globalMax=Math.max.apply(null,allMax);
        priceRange.min=priceRange.globalMin;
        priceRange.max=priceRange.globalMax;
      }
      cb();
    })
    .catch(function(){cb()});
  }

  /* ---- gather unique filter values ---- */
  function getFilterOptions(){
    var brands={};var colors={};var storages={};
    productData.forEach(function(p){
      brands[p.vendor]=(brands[p.vendor]||0)+1;
      p.colors.forEach(function(c){colors[c]=(colors[c]||0)+1});
      p.storages.forEach(function(s){storages[s]=(storages[s]||0)+1});
    });
    var storageKeys=Object.keys(storages).sort(function(a,b){return parseInt(a)-parseInt(b)});
    return {
      brand:Object.keys(brands).sort(),
      color:Object.keys(colors).sort(),
      storage:storageKeys,
      availability:['In Stock','Sold Out']
    };
  }

  /* ---- build the filter bar ---- */
  function buildFilterBar(){
    var wrap=document.querySelector('.tms-filter-bar-wrap');
    if(!wrap)return;
    wrap.innerHTML='';

    var bar=document.createElement('div');
    bar.className='tms-filter-bar';

    var pillRow=document.createElement('div');
    pillRow.className='tms-pill-row';

    var opts=getFilterOptions();
    var filters=[
      {key:'brand',label:'Brands',options:opts.brand},
      {key:'color',label:'Color',options:opts.color},
      {key:'storage',label:'Storage',options:opts.storage},
      {key:'availability',label:'Availability',options:opts.availability}
    ];

    filters.forEach(function(f){
      pillRow.appendChild(mkFilterPill(f));
    });

    /* price pill — visible on mobile only (CSS hides on desktop) */
    var pricePill=document.createElement('div');
    pricePill.className='tms-pill-wrap tms-pill-wrap--price';
    var priceBtn=document.createElement('button');
    priceBtn.className='tms-pill-toggle';
    priceBtn.setAttribute('type','button');
    priceBtn.innerHTML='Price <svg class="tms-chev" width="10" height="6" viewBox="0 0 10 6"><polyline points="1,1 5,5 9,1" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
    priceBtn.addEventListener('click',function(e){
      e.stopPropagation();
      openPriceSheet();
    });
    pricePill.appendChild(priceBtn);
    pillRow.appendChild(pricePill);

    bar.appendChild(pillRow);
    bar.appendChild(mkSortPill());
    wrap.appendChild(bar);

    /* price display */
    var priceDisp=document.createElement('div');
    priceDisp.className='tms-price-display';
    priceDisp.id='tms-price-display';
    priceDisp.textContent='$'+Math.round(priceRange.globalMin)+' — $'+Math.round(priceRange.globalMax);
    wrap.appendChild(priceDisp);

    /* price slider */
    var sliderWrap=document.createElement('div');
    sliderWrap.className='tms-price-slider-wrap';
    sliderWrap.innerHTML='<input type="range" class="tms-range tms-range-min" min="'+priceRange.globalMin+'" max="'+priceRange.globalMax+'" value="'+priceRange.globalMin+'" step="5">'
      +'<input type="range" class="tms-range tms-range-max" min="'+priceRange.globalMin+'" max="'+priceRange.globalMax+'" value="'+priceRange.globalMax+'" step="5">';
    wrap.appendChild(sliderWrap);

    var rMin=sliderWrap.querySelector('.tms-range-min');
    var rMax=sliderWrap.querySelector('.tms-range-max');
    function onSlide(){
      var lo=parseInt(rMin.value);var hi=parseInt(rMax.value);
      if(lo>hi){var tmp=lo;lo=hi;hi=tmp}
      priceRange.min=lo;priceRange.max=hi;
      var lbl=document.getElementById('tms-price-display');
      if(lbl)lbl.textContent='$'+lo+' — $'+hi;
      applyFilters();
    }
    rMin.addEventListener('input',onSlide);
    rMax.addEventListener('input',onSlide);

    /* close desktop dropdowns on outside click */
    document.addEventListener('click',function(e){
      if(!e.target.closest('.tms-pill-wrap') && !e.target.closest('.tms-sort-wrap')){
        closeAllDesktop();
      }
    });
  }

  /* ---- filter pill ---- */
  function mkFilterPill(f){
    var wrap=document.createElement('div');
    wrap.className='tms-pill-wrap';
    wrap.setAttribute('data-filter-key',f.key);

    var btn=document.createElement('button');
    btn.className='tms-pill-toggle';
    btn.setAttribute('type','button');
    btn.setAttribute('data-label',f.label);
    btn.innerHTML=f.label+' <svg class="tms-chev" width="10" height="6" viewBox="0 0 10 6"><polyline points="1,1 5,5 9,1" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

    var menu=document.createElement('div');
    menu.className='tms-pill-menu';

    f.options.forEach(function(opt){
      var row=document.createElement('label');
      row.className='tms-filter-option';
      var cb=document.createElement('input');
      cb.type='checkbox';
      cb.className='tms-filter-cb';
      cb.value=opt;
      cb.setAttribute('data-filter-key',f.key);
      cb.addEventListener('change',function(){
        toggleFilterValue(f.key,opt,cb.checked);
        updatePillLabel(btn,f.label,f.key);
        applyFilters();
      });
      var span=document.createElement('span');
      span.className='tms-filter-option-text';
      span.textContent=capitalize(opt);
      row.appendChild(cb);
      row.appendChild(span);
      menu.appendChild(row);
    });

    var reset=document.createElement('button');
    reset.className='tms-filter-reset';
    reset.textContent='Clear';
    reset.setAttribute('type','button');
    reset.addEventListener('click',function(e){
      e.stopPropagation();
      activeFilters[f.key]=[];
      menu.querySelectorAll('.tms-filter-cb').forEach(function(c){c.checked=false});
      updatePillLabel(btn,f.label,f.key);
      applyFilters();
    });
    menu.appendChild(reset);

    wrap.appendChild(btn);
    wrap.appendChild(menu);

    btn.addEventListener('click',function(e){
      e.stopPropagation();
      if(isMobile()){
        openBottomSheet(f);
      }else{
        var wasOpen=menu.classList.contains('tms-pill-menu--open');
        closeAllDesktop();
        if(!wasOpen)menu.classList.add('tms-pill-menu--open');
      }
    });

    return wrap;
  }

  /* ---- sort pill ---- */
  function mkSortPill(){
    var wrap=document.createElement('div');
    wrap.className='tms-sort-wrap';

    var btn=document.createElement('button');
    btn.className='tms-pill-toggle';
    btn.setAttribute('type','button');
    btn.id='tms-sort-btn';
    btn.innerHTML='Best selling <svg class="tms-chev" width="10" height="6" viewBox="0 0 10 6"><polyline points="1,1 5,5 9,1" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';

    var menu=document.createElement('div');
    menu.className='tms-pill-menu';

    var sortOpts=getSortOptions();
    sortOpts.forEach(function(s){
      var row=document.createElement('div');
      row.className='tms-pill-option';
      row.textContent=s.label;
      row.addEventListener('click',function(e){
        e.stopPropagation();
        currentSort=s.val;
        btn.innerHTML=s.label+' <svg class="tms-chev" width="10" height="6" viewBox="0 0 10 6"><polyline points="1,1 5,5 9,1" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
        closeAllDesktop();
        closeBottomSheet();
        applyFilters();
      });
      menu.appendChild(row);
    });

    wrap.appendChild(btn);
    wrap.appendChild(menu);

    btn.addEventListener('click',function(e){
      e.stopPropagation();
      if(isMobile()){
        openSortSheet();
      }else{
        var wasOpen=menu.classList.contains('tms-pill-menu--open');
        closeAllDesktop();
        if(!wasOpen)menu.classList.add('tms-pill-menu--open');
      }
    });

    return wrap;
  }

  function getSortOptions(){
    return [
      {val:'best-selling',label:'Best selling'},
      {val:'price-asc',label:'Price: Low to High'},
      {val:'price-desc',label:'Price: High to Low'},
      {val:'title-asc',label:'Alphabetically: A-Z'},
      {val:'title-desc',label:'Alphabetically: Z-A'}
    ];
  }

  /* ---- toggle a filter value on/off ---- */
  function toggleFilterValue(key,val,on){
    if(on){
      if(activeFilters[key].indexOf(val)===-1)activeFilters[key].push(val);
    }else{
      activeFilters[key]=activeFilters[key].filter(function(v){return v!==val});
    }
  }

  /* ---- update pill label with count ---- */
  function updatePillLabel(btn,baseLabel,key){
    var count=activeFilters[key].length;
    var chev=' <svg class="tms-chev" width="10" height="6" viewBox="0 0 10 6"><polyline points="1,1 5,5 9,1" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
    if(count>0){
      btn.innerHTML=baseLabel+' ('+count+')'+chev;
      btn.classList.add('tms-pill-toggle--active');
    }else{
      btn.innerHTML=baseLabel+chev;
      btn.classList.remove('tms-pill-toggle--active');
    }
  }

  function closeAllDesktop(){
    document.querySelectorAll('.tms-pill-menu--open').forEach(function(m){
      m.classList.remove('tms-pill-menu--open');
    });
  }

  /* ---- sync checkboxes between desktop pills and bottom sheet ---- */
  function syncAllCheckboxes(key){
    var cbs=document.querySelectorAll('.tms-filter-cb[data-filter-key="'+key+'"]');
    cbs.forEach(function(cb){
      cb.checked=activeFilters[key].indexOf(cb.value)!==-1;
    });
  }

  /* ============================================================
     BOTTOM SHEET (mobile only)
     ============================================================ */
  var sheetEl=null;
  var backdropEl=null;

  function ensureSheet(){
    if(sheetEl)return;
    backdropEl=document.createElement('div');
    backdropEl.className='tms-bs-backdrop';
    backdropEl.addEventListener('click',closeBottomSheet);
    sheetEl=document.createElement('div');
    sheetEl.className='tms-bottom-sheet';
    document.body.appendChild(backdropEl);
    document.body.appendChild(sheetEl);
  }

  function openBottomSheet(f){
    ensureSheet();
    closeAllDesktop();
    sheetEl.innerHTML='';

    /* header */
    var header=document.createElement('div');
    header.className='tms-bs-header';
    var hTitle=document.createElement('span');
    hTitle.className='tms-bs-title';
    hTitle.textContent=f.label;
    var hClose=document.createElement('button');
    hClose.className='tms-bs-close';
    hClose.setAttribute('type','button');
    hClose.innerHTML='&#10005;';
    hClose.addEventListener('click',closeBottomSheet);
    header.appendChild(hTitle);
    header.appendChild(hClose);
    sheetEl.appendChild(header);

    /* body */
    var body=document.createElement('div');
    body.className='tms-bs-body';

    f.options.forEach(function(opt){
      var row=document.createElement('label');
      row.className='tms-bs-option';
      var cb=document.createElement('input');
      cb.type='checkbox';
      cb.className='tms-bs-cb';
      cb.value=opt;
      cb.checked=activeFilters[f.key].indexOf(opt)!==-1;
      cb.addEventListener('change',function(){
        toggleFilterValue(f.key,opt,cb.checked);
        syncAllCheckboxes(f.key);
        updatePillByKey(f.key);
        applyFilters();
      });
      var span=document.createElement('span');
      span.className='tms-bs-option-text';
      span.textContent=capitalize(opt);
      row.appendChild(cb);
      row.appendChild(span);
      body.appendChild(row);
    });

    /* clear */
    var clearBtn=document.createElement('button');
    clearBtn.className='tms-bs-clear';
    clearBtn.setAttribute('type','button');
    clearBtn.textContent='Clear All';
    clearBtn.addEventListener('click',function(){
      activeFilters[f.key]=[];
      body.querySelectorAll('.tms-bs-cb').forEach(function(c){c.checked=false});
      syncAllCheckboxes(f.key);
      updatePillByKey(f.key);
      applyFilters();
    });
    body.appendChild(clearBtn);

    sheetEl.appendChild(body);
    showSheet();
  }

  function openPriceSheet(){
    ensureSheet();
    closeAllDesktop();
    sheetEl.innerHTML='';

    var header=document.createElement('div');
    header.className='tms-bs-header';
    var hTitle=document.createElement('span');
    hTitle.className='tms-bs-title';
    hTitle.textContent='Price';
    var hClose=document.createElement('button');
    hClose.className='tms-bs-close';
    hClose.setAttribute('type','button');
    hClose.innerHTML='&#10005;';
    hClose.addEventListener('click',closeBottomSheet);
    header.appendChild(hTitle);
    header.appendChild(hClose);
    sheetEl.appendChild(header);

    var body=document.createElement('div');
    body.className='tms-bs-body tms-bs-body--price';
    var lbl=document.createElement('div');
    lbl.className='tms-bs-price-label';
    lbl.id='tms-bs-price-label';
    lbl.textContent='$'+Math.round(priceRange.min)+' — $'+Math.round(priceRange.max);
    body.appendChild(lbl);

    var sw=document.createElement('div');
    sw.className='tms-bs-slider-wrap';
    sw.innerHTML='<input type="range" class="tms-range tms-range-min" min="'+priceRange.globalMin+'" max="'+priceRange.globalMax+'" value="'+Math.round(priceRange.min)+'" step="5">'
      +'<input type="range" class="tms-range tms-range-max" min="'+priceRange.globalMin+'" max="'+priceRange.globalMax+'" value="'+Math.round(priceRange.max)+'" step="5">';
    body.appendChild(sw);
    sheetEl.appendChild(body);

    var rMin=sw.querySelector('.tms-range-min');
    var rMax=sw.querySelector('.tms-range-max');
    function onSlide(){
      var lo=parseInt(rMin.value);var hi=parseInt(rMax.value);
      if(lo>hi){var t=lo;lo=hi;hi=t}
      priceRange.min=lo;priceRange.max=hi;
      document.getElementById('tms-bs-price-label').textContent='$'+lo+' — $'+hi;
      var dMin=document.querySelector('.tms-price-slider-wrap .tms-range-min');
      var dMax=document.querySelector('.tms-price-slider-wrap .tms-range-max');
      if(dMin)dMin.value=lo;if(dMax)dMax.value=hi;
      var dLbl=document.getElementById('tms-price-display');
      if(dLbl)dLbl.textContent='$'+lo+' — $'+hi;
      applyFilters();
    }
    rMin.addEventListener('input',onSlide);
    rMax.addEventListener('input',onSlide);
    showSheet();
  }

  function openSortSheet(){
    ensureSheet();
    closeAllDesktop();
    sheetEl.innerHTML='';

    var header=document.createElement('div');
    header.className='tms-bs-header';
    var hTitle=document.createElement('span');
    hTitle.className='tms-bs-title';
    hTitle.textContent='Sort By';
    var hClose=document.createElement('button');
    hClose.className='tms-bs-close';
    hClose.setAttribute('type','button');
    hClose.innerHTML='&#10005;';
    hClose.addEventListener('click',closeBottomSheet);
    header.appendChild(hTitle);
    header.appendChild(hClose);
    sheetEl.appendChild(header);

    var body=document.createElement('div');
    body.className='tms-bs-body';
    var sortBtn=document.getElementById('tms-sort-btn');
    getSortOptions().forEach(function(s){
      var row=document.createElement('div');
      row.className='tms-bs-sort-option';
      if(currentSort===s.val)row.classList.add('tms-bs-sort-option--active');
      row.textContent=s.label;
      row.addEventListener('click',function(){
        currentSort=s.val;
        if(sortBtn)sortBtn.innerHTML=s.label+' <svg class="tms-chev" width="10" height="6" viewBox="0 0 10 6"><polyline points="1,1 5,5 9,1" fill="none" stroke="currentColor" stroke-width="1.5"/></svg>';
        applyFilters();
        closeBottomSheet();
      });
      body.appendChild(row);
    });
    sheetEl.appendChild(body);
    showSheet();
  }

  function showSheet(){
    document.body.classList.add('tms-scroll-locked');
    backdropEl.classList.add('tms-bs-backdrop--open');
    sheetEl.offsetHeight;/* force reflow */
    sheetEl.classList.add('tms-bottom-sheet--open');
  }

  function closeBottomSheet(){
    if(!sheetEl)return;
    sheetEl.classList.remove('tms-bottom-sheet--open');
    if(backdropEl)backdropEl.classList.remove('tms-bs-backdrop--open');
    document.body.classList.remove('tms-scroll-locked');
  }

  function updatePillByKey(key){
    var wrap=document.querySelector('.tms-pill-wrap[data-filter-key="'+key+'"]');
    if(!wrap)return;
    var btn=wrap.querySelector('.tms-pill-toggle');
    if(!btn)return;
    var label=btn.getAttribute('data-label');
    if(label)updatePillLabel(btn,label,key);
  }

  /* ============================================================
     CLIENT-SIDE FILTERING ENGINE
     ============================================================ */
  function applyFilters(){
    var grid=document.querySelector('.product-grid__container');
    if(!grid)return;
    var cards=grid.querySelectorAll('.product-card');
    var sorted=getSortedProducts();
    var posMap={};
    sorted.forEach(function(p,i){posMap[p.id]=i});
    var visibleCount=0;

    cards.forEach(function(card){
      var m=card.id.match(/product-card-(\d+)/);
      if(!m)return;
      var pid=m[1];
      var pd=productData.find(function(p){return p.id===pid});
      if(!pd){card.style.display='';return}

      var show=true;

      /* brand */
      if(activeFilters.brand.length>0){
        if(activeFilters.brand.indexOf(pd.vendor)===-1)show=false;
      }
      /* color */
      if(show && activeFilters.color.length>0){
        var hasC=pd.colors.some(function(c){return activeFilters.color.indexOf(c)!==-1});
        if(!hasC)show=false;
      }
      /* storage */
      if(show && activeFilters.storage.length>0){
        var hasS=pd.storages.some(function(s){return activeFilters.storage.indexOf(s)!==-1});
        if(!hasS)show=false;
      }
      /* availability */
      if(show && activeFilters.availability.length>0){
        var wI=activeFilters.availability.indexOf('In Stock')!==-1;
        var wS=activeFilters.availability.indexOf('Sold Out')!==-1;
        if(wI && !wS && !pd.available)show=false;
        if(wS && !wI && pd.available)show=false;
      }
      /* price */
      if(show){
        if(pd.minPrice>priceRange.max || pd.maxPrice<priceRange.min)show=false;
      }

      card.style.display=show?'':'none';
      if(show)visibleCount++;
      if(posMap[pid]!==undefined)card.style.order=posMap[pid];
    });

    var countEl=document.querySelector('.products_count');
    if(countEl)countEl.textContent=visibleCount+' product'+(visibleCount!==1?'s':'');
  }

  function getSortedProducts(){
    var arr=productData.slice();
    switch(currentSort){
      case 'price-asc':arr.sort(function(a,b){return a.minPrice-b.minPrice});break;
      case 'price-desc':arr.sort(function(a,b){return b.minPrice-a.minPrice});break;
      case 'title-asc':arr.sort(function(a,b){return a.title.localeCompare(b.title)});break;
      case 'title-desc':arr.sort(function(a,b){return b.title.localeCompare(a.title)});break;
      default:arr.sort(function(a,b){return originalOrder.indexOf(a.id)-originalOrder.indexOf(b.id)});break;
    }
    return arr;
  }

  /* ---- start ---- */
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  }else{
    init();
  }
})();
